module.exports = __webpack_public_path__ + "static/media/sphinx-treasure.012bce3e.png";